<template>
  <div>
    <!-- Hijri Datepicker -->
    <datepicker
      :id="id"
      :label="label"
      :value="value"
      :max="max"
      :min="min"
      :clearable="clearable"
      :validates="validates"
      :placeholder="placeholder"
      :data-vv-name="attrs['data-vv-name']"
      :data-vv-as="attrs['data-vv-as']"
      :error-messages="errors.first(id)"
      :disabled="disabled"
      :readonly="readonly"
      :locale="locale"
      @change="
        updateValue($event);
        $emit('change', $event);
      "
    ></datepicker>
  </div>
</template>

<script>
import Datepicker from './datepicker';

export default {
  inject: ['$validator'],
  components: { Datepicker },
  props: {
    id: {
      type: String,
      required: true,
    },
    dataVVAsValue: {
      required: false,
      type: String,
    },
    value: { required: true },
    label: { required: false },
    disabled: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    validates: { required: false },
    locale: {
      type: String,
      default: 'en-US',
    },
    placeholder: {
      type: String,
      required: false,
    },
    max: { type: String },
    min: { type: String },
  },
  computed: {
    isHijri() {
      return this.locale === 'ar-SA';
    },
    attrs() {
      return this.$attrs;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>
